import { observer } from "mobx-react-lite";
import { ReactElement, useEffect, useState, useRef } from "react";
import { useStore } from "../../root-store-context";
import useBreakpoint from "use-breakpoint";
import { Button, Flex, Space, Spin } from "antd";

const AllAccessUserGuide = observer((): ReactElement => {
    const { apiStore } = useStore();
    const BREAKPOINTS = { mobile: 0, desktop: 768 };
    const { breakpoint } = useBreakpoint(BREAKPOINTS, "mobile");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [src, setSrc] = useState<string>("");
    const objectUrlRef = useRef<string>("");

    useEffect(() => {

        const load = async () => {
            try {
                const res = await apiStore.CommonApiClient.downloadAllAccessUserGuide();
                const blob = new Blob([res.data], { type: "application/pdf" });

                const url = URL.createObjectURL(blob);
                objectUrlRef.current = url;
                setSrc(url);
            } catch (err) {
                console.error("Failed to load All Access User Guide", err);
            } finally {
                setIsLoading(false);
            }
        };

        load();

        return () => {
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
                objectUrlRef.current = "";
            }
        };
    }, [apiStore.CommonApiClient]);

    return (
        <Spin spinning={isLoading}>
            <Flex justify="space-between" wrap="wrap" align="center" gap="middle" style={{ padding: 10 }}>
                <div style={{ display: "flex", width: "100%", flexWrap: "wrap", justifyContent: "space-between" }}>
                    <Space style={{ flexWrap: "wrap" }}>
                        <h2 style={{ width: "280px" }}>All Access User Guide</h2>
                    </Space>
                </div>
            </Flex>
            <Button type="primary" disabled={!src} style={{ display: "block", marginBottom: 16 }} onClick={() => window.open(src, "_blank", "noopener,noreferrer")}>Open in new Tab</Button>
            <iframe src={src} title="User Guide" style={{ border: "none", width: "100%", height: breakpoint === "desktop" ? "68vh" : "70vh" }}></iframe>
        </Spin>
    )
})

export default AllAccessUserGuide;
